// Duplicated in apps/cca/shared/utils/addressVerification.ts — CA and CCA must apply the same checks, keep in sync.

export type Locality = { suburb: string; postcode: string }

const normalize = (value: string) => value.trim().toLowerCase().replace(/\s+/g, ' ')

export const isSameLocality = (entered: Locality, found: Locality | undefined): boolean =>
  Boolean(found) &&
  normalize(entered.suburb) === normalize(found!.suburb) &&
  normalize(entered.postcode) === normalize(found!.postcode)
